<template>
  <v-autocomplete
    class="mt-2"
    :items="items"
    :rules="[rules.required]"
    :loading="isLoading"
    :error-messages="error"
    @input="$emit('input', formatItem(item))"
    label="Veículo*"
    v-model="item"
    item-text="plate"  
    return-object  
    clearable
    outlined
    dense    
    multiple
    ></v-autocomplete>
</template>

<script>
import vehicleService from '@/services/vehicle.service';

export default {
  name: 'OrderVehicleAutoComplete',

  props: {
    value: {
      type: Array,
      default: null
    },

    listKind: {
      type: String,
      default: 'list'
    }
  },

  data: () => ({
    isLoading: false,
    error: null,
    items: [],
    item: null,
    rules: {
      required: value => !!value || "Esse campo deve ser preenchido"
    },    
  }),

  mounted() {    
    this.listVehicles();
  },

  methods: {
    listVehicles() {
      this.isLoading = true;
      this.mountService().subscribe(response => {
        this.items = response;
        this.isLoading = false;
      }, error => {
        this.error = 'Erro ao carregar os veículos';
        this.isLoading = false;
      });
    },

    mountService() {
      switch (this.listKind) {
        case 'list':
          return vehicleService.list();
        case 'exclusion':
          return vehicleService.listForExclusion();
        default:
          return vehicleService.list();
      }
    },

    formatItem(items) {      
      if (!items.length) return [];

      return items.map(item => ({
        plate: item.plate,
        transportId: item.company_vehicle_id
      }));
    }
  },
};
</script>